import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_USERS } from "../../../utils/constants";
import { UserInterface } from "../../../models/UserModel/User";
import userService from "../../../services/userService/userService";

const useUsers = (page: number, pageSize: number) =>
  useQuery<UserInterface[], Error>({
    queryKey: [
      CACHE_KEY_USERS,
      page > 0 ? page : null,
      pageSize > 0 ? pageSize : null,
    ],
    queryFn: () => userService.GetAll(page, pageSize),
  });

export default useUsers;
